export default "__VITE_ASSET__DDCnC6xc__"